export enum EVENT_TYPE {
    VIEW = 'view',
    ACTION = 'action'
}

export const ENTERPRISE_HOME_PAGE = 'enterprise_home_page'

export const VIEW_PAGE_ENTERPRISE_LANDING = 'view_page_enterprise_landing'

export const VIEW_LEAD_GEN_POPUP = 'view_lead_gen_popup'

export const TAP_EVENT = {
    TAP_LEAD_GEN_POPUP: 'tap_lead_gen_popup',
    TAP_NAV_BAR_OPTIONS: 'tap_nav_bar_options',
    TAP_BTN: 'tap_btn',
}
